import { Component, OnInit } from '@angular/core';
import { ModalRedirectToService } from '../modal-redirect-to/modal-redirect-to.service';
import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';
import { ModalService } from 'app/shared/modal/modal.service';

@Component({
  selector: 'modal-redirect-to',
  templateUrl: './modal-redirect-to.component.html',
  styleUrls: ['./modal-redirect-to.component.scss'],
})
export class ModalRedirectToComponent implements OnInit {

  private urlAtual = '';

  constructor(
    private redirectModalService: ModalRedirectToService,
    private modalService: ModalService,
    private blockSpinner: BlockingSpinnerService) { }

  ngOnInit() {
    this.redirectModalService.init(this);
  }

  open(url) {
    this.urlAtual = url;
    this.modalService.open('modal-redirect-to');
  }

  close() {
    this.modalService.close('modal-redirect-to');
  }

  sim() {
    this.blockSpinner.show();
    window.location.href = this.urlAtual;
  }

  nao() {}
}
